import type { ComponentProps } from "react";
import ShippingAgencyTransferDecisionDrawer from "../ShippingAgencyTransferDecisionDrawer";

type Props = Omit<ComponentProps<typeof ShippingAgencyTransferDecisionDrawer>, "decision">;

const RejectShippingAgencyTransferDrawer = (props: Props) => (
  <ShippingAgencyTransferDecisionDrawer {...props} decision="reject" />
);

export default RejectShippingAgencyTransferDrawer;
